import cx from "classnames";
import React, { useState } from "react";
import styles from "./selector.module.scss";
import { ISearchSelectorOptModel } from "../../types/interfaces";
import SelectorDropdown from "../molecules/selectorDropdown/SelectorDropdown";
import { ChevronDownIcon, ChevronUpIcon } from "@gataca/design-system/web";
import { useTranslation } from "react-i18next";

type SelectorProps = {
  className?: string;
  options?: ISearchSelectorOptModel[];
  selectedOption: ISearchSelectorOptModel;
  setSelectedOption: (x?: any) => void;
};

const Selector: React.FC<SelectorProps> = React.memo(
  (props) => {
    const {
      className,
      options = [],
      selectedOption,
      setSelectedOption,
    } = props;

    // Const
    const { t } = useTranslation();

    // States
    const [showDropdown, setShowDropdown] = useState(false);

    // Functions
    const onItemClick = (selectedOption) => {
      setSelectedOption(selectedOption);
      setShowDropdown(false);
    };

    return (
      <div className={cx(styles.selectorContainer, className && className)}>
        <div
          className={cx(styles.selectorContainer__displayValue)}
          onClick={() => setShowDropdown((showDropdown) => !showDropdown)}>
          <p className={`${cx("buttonSM")}`}>{t(selectedOption?.text)}</p>
          {showDropdown ? (
            <ChevronUpIcon color={"grey"} size={"24"} />
          ) : (
            <ChevronDownIcon color={"grey"} size={"24"} />
          )}
        </div>

        {showDropdown ? (
          <>
            <SelectorDropdown
              optionsFilter={options}
              onChange={(item) => onItemClick(item)}
              selectedOption={selectedOption}
            />
            <div
              className={styles.selectorContainer__backgroundLayer}
              onClick={() => setShowDropdown(false)}></div>
          </>
        ) : null}
      </div>
    );
  }
);

export default Selector;
